<script lang="ts" setup>
import { PropType } from 'vue'

/* Components */
import HalvePizzaElement from '@/components/Halves/HalvePizzaElement.vue'

/* Types */
import { useAppStore } from '~/store/app/app'

/* Types */
import { ConstructorPizza } from '@/types/api/api-v3/halves'
import { Product } from '@/types/api/api-v3/product'

const { showSnackbar } = useAppStore()

enum SelectedHalve {
  LEFT = 'left',
  RIGHT = 'right',
}

const descriptionPage = 'Выберите две пиццы для левой и правой части пиццы'

const props = defineProps({
  products: {
    type: Array as PropType<Product[]>,
    required: false,
    default: () => [],
  },
  constructorPizza: {
    type: Object as PropType<ConstructorPizza>,
    required: true,
  },
})

const emits = defineEmits(['removeHalveOfConstructor', 'addHalveInConstructor'])

const checkSelectedHalve = (product: Product, type: SelectedHalve) => {
  if (type === SelectedHalve.RIGHT) {
    return props.constructorPizza?.rightHalve?.id === product.id
  }

  return props.constructorPizza?.leftHalve?.id === product.id
}

const addHalveInConstructor = (product: Product) => {
  const { leftHalve, rightHalve } = props.constructorPizza

  // добавляем половинку, если есть пустой слот в конструкторе
  if (!leftHalve || !rightHalve) {
    if (leftHalve?.id === product.id) {
      emits('removeHalveOfConstructor', 'leftHalve')
      return
    }

    if (rightHalve?.id === product.id) {
      emits('removeHalveOfConstructor', 'rightHalve')

      return
    }

    emits('addHalveInConstructor', product)

    return
  }

  if (leftHalve?.id === product.id)
    emits('removeHalveOfConstructor', 'leftHalve')

  if (rightHalve?.id === product.id)
    emits('removeHalveOfConstructor', 'rightHalve')

  if (leftHalve?.id !== product.id && rightHalve?.id !== product.id)
    showSnackbar({
      message: 'Вы можете выбрать только 2 половинки пицц',
    })
}
</script>

<template>
  <div class="halves-list">
    <h2 class="halves-list__description">{{ descriptionPage }}</h2>
    <div class="halves-list__wrapper">
      <halve-pizza-element
        v-for="product in products"
        :key="product.id"
        class="halves-list__product"
        :product="product"
        :constructor-pizza="constructorPizza"
        :is-selected-left-halve="
          checkSelectedHalve(product, SelectedHalve.LEFT)
        "
        :is-selected-right-halve="
          checkSelectedHalve(product, SelectedHalve.RIGHT)
        "
        :description="product.description"
        @select-halve-pizza="addHalveInConstructor"
      />
    </div>
  </div>
</template>
<style lang="scss" scoped>
.halves-list {
  &__description {
    margin-bottom: 40px;
    font-size: 22px;
    font-weight: 800;
    line-height: 26px;
  }

  &__wrapper {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 40px 48px;
    width: 100%;
  }

  @include media('<=desktop-mini') {
    width: 100%;

    &__description {
      font-size: 16px;
      line-height: 19px;
    }
  }

  @include media('<=tablet') {
    &__wrapper {
      grid-template-columns: repeat(auto-fill, minmax(95px, 1fr));
      gap: 24px 20px;
    }
  }

  @include media('<=portrait-phone') {
    &__wrapper {
      grid-template-columns: repeat(auto-fill, minmax(95px, 95px));
    }
  }
}
</style>
